<app-view-title Title="{{'Intellitrailer.Home.Home.TitleMap' | translate: 'Choose place'}}" [isPrimaryColor]="true"></app-view-title>

<view-content [centered]="true" [fullscreen]="true" [nopadding]="true">
  <location-map #map mode="Local" [locations]="locations" [showPlaceSearch]="showSearch" [(selectedLocation)]="selectedLocation" (locationConfirmed)="selectLocation()"></location-map>
</view-content>


<view-actions>
  <div class="row">
    <div class="col-6">
      <button type="button" mat-raised-button color="accent" (click)="toggleSearch()" class="mw-160">{{'Intellitrailer_Home_Home_cmdFindPlace' | translate: 'Find Place'}}</button>
    </div>
    <div class="col-6">
      <button  type="button" mat-raised-button color="primary" (click)="toggleLocationList()" class="mw-160">{{'Intellitrailer_Home_Home_cmdShowlist' | translate: 'Show List'}}</button>
    </div>
  </div>
 
</view-actions>


